var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWheelLarge = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "a",
  cx: 17,
  cy: 17,
  r: 17
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#007AC3",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#85BC20",
  mask: "url(#b)",
  d: "M5 5h24v24H5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A6D1EA",
  mask: "url(#b)",
  d: "M0 13h34v8H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#409BD2",
  mask: "url(#b)",
  d: "M13 13h21v8H13z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A6D1EA",
  mask: "url(#b)",
  d: "M13 0h8v34h-8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#409BD2",
  mask: "url(#b)",
  d: "M13 13h8v21h-8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A4CD58",
  mask: "url(#b)",
  d: "M13 13h16v16H13z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D4E8B1",
  mask: "url(#b)",
  d: "M5 5h16v16H5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#409BD2",
  mask: "url(#b)",
  d: "M0 0h13v13H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E5202E",
  mask: "url(#b)",
  d: "M13 13h8v8h-8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A4CD58",
  mask: "url(#b)",
  d: "M5 5h8v8H5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#85BC20",
  mask: "url(#b)",
  d: "M21 21h8v8h-8z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#474747"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.25 31h.645c.131 0 .246.015.33.047.272.076.404.274.404.501 0 .322-.252.488-.488.542v.01c.141.067.361.463.609.9h-.484c-.272-.475-.434-.789-.524-.796h-.071V33h-.421v-2zm.522.884c.216 0 .406-.082.406-.288 0-.123-.055-.216-.167-.244a.577.577 0 00-.229-.03h-.111v.562h.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34 32a2 2 0 11-4 0 2 2 0 014 0zm-2.001-1.579a1.579 1.579 0 100 3.158 1.579 1.579 0 000-3.158z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWheelLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wheel-large.14abea48e5bb34dd022dea182d250f5b.svg";